export default __webpack_public_path__ + "static/media/chatify.2cf99102.png";